import React, { useState, useEffect } from 'react';

function Step4({ formData, errors, onChange }) {
  const [epsList, setEpsList] = useState([]);
  const [loading, setLoading] = useState(true);

  // Consultar las EPS al cargar el componente
  useEffect(() => {
    const fetchEPS = async () => {
      try {
        const response = await fetch('https://api-utilidades.aliadosestrategicos360.com/api/eps'); 
        const data = await response.json();
        setEpsList(data);
      } catch (error) {
        console.error("Error cargando las EPS:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEPS();
  }, []);

  return (
    <div className="step-panel">

      <div className="field-group">
        <label htmlFor="nivelEducativo">
          Nivel Educativo <span className="required">*</span>
        </label>
        <select
          id="nivelEducativo"
          name="nivelEducativo"
          value={formData.nivelEducativo}
          onChange={onChange}
        >
          <option value="">Select an option ...</option>
          <option value="primaria">Básica Primaria</option>
          <option value="bachiller">Bachiller</option>
          <option value="tecnologia">Tecnología</option>
          <option value="pregrado">Pregrado</option>
          <option value="postgrado">Posgrado</option>
        </select>
        {errors.nivelEducativo && <span className="field-error">{errors.nivelEducativo}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="estadoCivil">
          Estado Civil <span className="required">*</span>
        </label>
        <select
          id="estadoCivil"
          name="estadoCivil"
          value={formData.estadoCivil}
          onChange={onChange}
        >
          <option value="">Select an option ...</option>
          <option value="soltero">Soltero(a)</option>
          <option value="casado">Casado(a)</option>
          <option value="union libre">Unión Libre</option>
          <option value="divorciado">Divorciado(a)</option>
          <option value="viudo">Viudo(a)</option>
        </select>
        {errors.estadoCivil && <span className="field-error">{errors.estadoCivil}</span>}
      </div>

      {/* SELECT DE EPS */}
      <div className="field-group">
        <label htmlFor="eps">
          EPS (Salud) <span className="required">*</span>
        </label>
        <select
          id="eps"
          name="eps" // Asegúrate de que coincida con la propiedad en tu objeto inicial de formData
          value={formData.eps}
          onChange={onChange}
          disabled={loading}
        >
          {loading ? (
            <option value="">Cargando EPS...</option>
          ) : (
            <>
              <option value="">Seleccione una EPS ...</option>
              {epsList.map((item) => (
                <option key={item.id} value={item.nombre}>
                  {item.nombre}
                </option>
              ))}
            </>
          )}
        </select>
        {errors.eps && <span className="field-error">{errors.eps}</span>}
      </div>
      {/* ------------------------------------------- */}

      <div className="field-group">
        <label htmlFor="pension">
          AFP (PENSIÓN) <span className="required">*</span>
        </label>
        <select
          id="pension"
          name="pension"
          value={formData.pension}
          onChange={onChange}
        >
          <option value="">Seleccione una opción ...</option>
          <option value="porvenir">Porvenir</option>
          <option value="protección">Protección</option>
          <option value="colfondos">Colfondos</option>
          <option value="colpensiones">Colpensiones</option>
          <option value="skandia">Skandia (antes conocida como Old Mutual)</option>
          <option value="No lo sé">No lo sé</option>
        </select>
        {errors.pension && <span className="field-error">{errors.pension}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="cesantias">
          Fondo de Cesantías <span className="required">*</span>
        </label>
        <select
          id="cesantias"
          name="cesantias"
          value={formData.cesantias}
          onChange={onChange}
        >
          <option value="">Select an option ...</option>
          <option value="porvenir">Porvenir</option>
          <option value="protección">Protección</option>
          <option value="colfondos">Colfondos</option>
          <option value="colpensiones">Colpensiones</option>
          <option value="skandia">Skandia (antes conocida como Old Mutual)</option>
          <option value="fna">Fondo Nacional del Ahorro (FNA)</option>
          <option value="No lo sé">No lo sé</option>
        </select>
        {errors.cesantias && <span className="field-error">{errors.cesantias}</span>}
      </div>
      
      <div className="field-group">
        <label htmlFor="cajaCompensacion">
          Caja de Compensación Familiar <span className="required">*</span>
        </label>
        <input
          id="cajaCompensacion"
          name="cajaCompensacion"
          type="text"
          value={formData.cajaCompensacion}
          readOnly
          placeholder="COMFENALCO"
        />
      </div>

      <div className="field-group">
        <label htmlFor="arl">
          ARL - Administradora de Riesgos Laborales<span className="required">*</span>
        </label>
        <input
          id="arl"
          name="arl"
          type="text"
          value={formData.arl}
          readOnly
          placeholder="ARL SURA"
        />
      </div>

    </div>
  );
}

export default Step4;